<template>
  <div class="modal-tom" v-if="showCodeModal">
    <div class="modal-content col-md-3">
      <div class="d-flex flex-column" v-if="!accessCodeSuccess">
        <h4>Access Codes</h4>
        <p>Please enter your access code provided by your primary susbcriber.</p>
        <input type="text" class="form-control form-control-md mb-2" v-model="accessCode" />
        <div class="d-flex">
          <loading-button v-if="loading"></loading-button>
          <button v-else class="btn btn-primary" @click="submitAccessCode">Submit</button>
          <button class="btn" @click="toggleCodePopup">Cancel</button>
        </div>
      </div>
      <div class="d-flex flex-column" v-else>
        <h4>Success!</h4>
        <p>Click here to access your new account!</p>
        <button class="btn btn-primary" @click="signOut">Sign In</button>
      </div>
    </div>
  </div>
  <!-- <div class="modal-tom" v-if="customPlan">
    <CustomPlanForm
      @closeCustomQuoteModal="toggleCustomPlan"
      :user="user"
    ></CustomPlanForm>
  </div> -->
  <div class="card col-xl-8 col-12 bg-light m-5">
    <div class="card-header fw-bold mt-5 fs-6a p3">Select a Subscription Plan</div>
    <div class="card-body shadow pt-5 mb-5">
      <div class="col">
        <h5 class="mb-4 fw-bold fs-5">
          How many subscriptions would you like to purchase?
        </h5>
        <div class="d-flex mb-5">
          <button @click="singlePlanEvent" class="little-card" :class="singlePlan">
            <h6 class="fw-bold fs-5 my-5">Personal License</h6>
            <p class="fs-8 mt-4">$395 / Year</p>
            <p class="fs-8">
              CrimeTime Subscription <br />+ 1 Free Crimes Listing Booklet
            </p>
          </button>
          <button @click="multiplePlansEvent" class="mx-2 little-card" :class="multiplePlans">
            <h6 class="fw-bold fs-5 my-5">Multiple Licenses</h6>
            <p class="fs-8 mt-4">$395 / Year + $250 / Year Per Additional License</p>
            <p class="fs-8">
              CrimeTime Subscription <br />+ 1 Free Crimes Listing Booklet
            </p>
          </button>
          <button @click="toggleCustomPlan" class="mx-2 little-card">
            <h6 class="fw-bold fs-5 my-5">County License</h6>
            <p class="fs-8 mt-4">
              Contact us for a county discount and a free 1 month trial!
            </p>
          </button>
          <button @click="toggleCodePopup" class="mx-2 little-card">
            <h6 class="fw-bold fs-5 my-5">I have a Subscription</h6>
            <p class="fs-8 mt-4">Already have a subscription?</p>
            <p class="fs-8">Click here to sign up with your access code.</p>
          </button>
        </div>
        <div class="mb-5 d-flex flex-column" v-if="multiplePlans">
          <h3 class="fw-bold mb-4">How many plans would you like to purchase?</h3>
          <div class="d-flex mb-2 align-items-center">
            <button class="btn btn-primary" @click="decrementPlans">-</button>

            <span class="mx-5">{{ planCount }}</span>
            <button class="btn btn-primary" @click="incrementPlans">+</button>
          </div>
        </div>
        <div class="d-flex flex-column mb-5 col-md-8 p-0" v-if="singlePlan || multiplePlans">
          <span class="fs-5 fw-bold mb-2"><strong>Total:</strong> ${{ price }} / year</span>
          <h3 class="fw-bold mb-4">Select your preferred payment method</h3>
          <div class="d-flex flex-column mb-2">
            <div class="d-flex align-items-center">
              <input type="radio" v-model="paymentMethod" value="card" id="pm-card-input" name="paymentMethod" />
              <label for="pm-card-input " class="mb-0 pl-4">Credit/Debit Card</label>
            </div>
            <div class="d-flex align-items-center">
              <input type="radio" v-model="paymentMethod" value="us_bank_account" id="pm-ach-input" name="paymentMethod" />
              <label for="pm-ach-input " class="mb-0 pl-4">ACH Direct Debit/Bank Account</label>
            </div>
            <button style="max-width: 120px" class="btn btn-primary btn-md mt-5" v-if="!orderComplete" @click="placeOrder">
              Place Order
            </button>
          </div>
        </div>
      </div>
      <StripeCard class="col" :quantity="planCount" :price="price" :setupIntent="setupIntent" v-if="orderComplete" />
    </div>
  </div>
</template>
<script>
import StripeCard from "./StripeCard.vue";
import axios from "axios";
import LoadingButton from "../../components/utils/LoadingButton.vue";
// import CustomPlanForm from "../../components/Home/Registration/CustomPlanForm.vue";
export default {
  components: {
    StripeCard,
    LoadingButton,
    // CustomPlanForm,
  },
  data() {
    return {
      singlePlan: false,
      multiplePlans: false,
      customPlan: false,
      planCount: 1,
      price: 395,
      orderComplete: false,
      setupIntent: {},
      showCodeModal: false,
      accessCode: "",
      accessCodeSuccess: false,
      paymentMethod: "",
    };
  },
  props: {
    user: {
      type: Object,
    },
    token: {
      type: Object,
    },
  },
  methods: {
    toggleCodePopup() {
      this.showCodeModal = !this.showCodeModal;
    },
    singlePlanEvent() {
      this.multiplePlans = false;
      this.singlePlan = true;
      this.planCount = 1;
      this.orderComplete = false;
      this.price = 395;
      // console.log("single");
    },
    multiplePlansEvent() {
      this.multiplePlans = true;
      this.singlePlan = false;
      this.orderComplete = false;
      this.price = 395;
      // console.log("multiple");
    },
    incrementPlans() {
      this.planCount += 1;
    },
    decrementPlans() {
      this.planCount -= 1;
      // console.log(planCount);
    },
    async placeOrder() {
      // console.log("Order Placed");

      const body = {
        planCount: this.planCount,
        price: this.price,
        user: this.user,
        paymentMethod: this.paymentMethod,
      };
      // console.log(body);
      const subscription = await axios
        .post(
          process.env.VUE_APP_ENDPOINT + "/api/stripesubscription/createSubscription",
          body,
          {
            headers: { Authorization: `Bearer ` + this.token },
          }
        )
        .then((data) => {
          // console.log(data);
          this.setupIntent = data.data.setupIntent;
          this.orderComplete = true;
        });
    },
    async checkCredentials() {
      // console.log("uuid:", SC.deviceUUID());
      try {
        let token = localStorage.getItem("user_token");
        if (token == "" || token === undefined) return false;
        let body = { user_token: token };

        // console.log("addressurl:::", process.env.VUE_APP_ENDPOINT);

        await axios
          .post(process.env.VUE_APP_ENDPOINT + "/api/auth/checkcredentials", body, {
            headers: { Authorization: `Bearer ` + token },
          })
          .then((data) => {
            data = data.data;
            // console.log("datadatadata:", data);

            if (data.authorized == true) {
              //this.$emit("user_authorized", this.authorized)

              // console.log("data.tokendata.token:", data.token);
              // console.log("data.tokendata.user_key:", data.key);
              // console.log("data.subscription_status:", data.subscription_status);
              localStorage.setItem("user_token", data.token);
              localStorage.setItem("user_key", data.key);

              this.token = data.token;
              return true;
            }
          })
          .catch((error) => {
            console.error(error);
            return false;
          });
      } catch (e) {
        // console.log(e);
        return false;
      }
    },
    // async submitAccessCode() {
    //   // console.log(this.accessCode);
    //   let token = localStorage.getItem("user_token");
    //   if (token == "" || token === undefined) return false;
    //   let body = { user_token: token };

    //   await axios
    //     .post(process.env.VUE_APP_ENDPOINT + "/api/auth/checkcredentials", body, {
    //       headers: { Authorization: `Bearer ` + token },
    //     })
    //     .then(async (creds) => {
    //       // console.log(creds);
    //       const user_attr = creds.data.user_attr;
    //       const checkedAccessCode = await axios
    //         .post(
    //           process.env.VUE_APP_ENDPOINT +
    //             `/api/subscriptions/accessCode?Column=AccessCode&Value=${this.accessCode.toUpperCase()}`
    //         )
    //         .then(async (result) => {
    //           // console.log(result.data);
    //           let bodyObject = {
    //             AccessCodeUsed: true,
    //             JWTUserId: user_attr.id,
    //             Id: result.data[0]?.Id,
    //             SubscriptionStatus: "Active",
    //           };

    //           if (result?.data?.length > 0 && result?.data[0].AccessCodeUsed == false) {
    //             let ac = result?.data[0];
    //             if (
    //               ac.SubscriptionStatus == 3 &&
    //               new Date(ac?.TrialEndDate) < new Date()
    //             ) {
    //               // console.log("unlimited access code used");
    //               const updatedUser = await axios
    //                 .patch(
    //                   process.env.VUE_APP_ENDPOINT + "/api/JWTUsers/AddSubscriberToUser",
    //                   {
    //                     Id: user_attr.id,
    //                     SubscriptionId: result.data[0]?.Id,
    //                   },
    //                   {
    //                     headers: { Authorization: "Bearer " + data.token },
    //                   }
    //                 )
    //                 .then((updatedUser) => {
    //                   // console.log(updatedUser);
    //                 });
    //               this.accessCodeSuccess = true;
    //             } else {
    //               const updatedCode = await axios
    //                 .patch(
    //                   process.env.VUE_APP_ENDPOINT + `/api/subscriptions`,
    //                   bodyObject,
    //                   {
    //                     headers: { Authorization: "Bearer " + data.token },
    //                   }
    //                 )
    //                 .then((updatedSubscription) => {
    //                   // console.log(updatedSubscription);
    //                   this.accessCodeSuccess = true;
    //                 });
    //             }
    //           }
    //         });
    //     })
    //     .catch(async (err) => {
    //       // console.log("futzing in the catch function", err.response);
    //       if (err?.response?.data?.foundUser?.id) {
    //         const userId = err?.response?.data?.foundUser?.id;
    //         const checkedAccessCode = await axios
    //           .post(
    //             process.env.VUE_APP_ENDPOINT +
    //               `/api/subscriptions/accessCode?Column=AccessCode&Value=${this.accessCode.toUpperCase()}`
    //           )
    //           .then(async (result) => {
    //             // console.log(result.data);
    //             if (
    //               result?.data?.length > 0 &&
    //               (result?.data[0].AccessCodeUsed == false ||
    //                 result?.data[0].SubscriptionTier == 3)
    //             ) {
    //               let ac = result?.data[0];

    //               if (
    //                 ac.SubscriptionTier == 3 &&
    //                 (ac.SubscriptionStatus == "Active" ||
    //                   (ac.SubscriptionStatus == "Trialing" &&
    //                     new Date(ac?.TrialEndDate) > new Date()))
    //               ) {
    //                 // console.log("unlimited access code used");
    //                 this.accessCodeSuccess = true;
    //                 const updatedUser = await axios.patch(
    //                   process.env.VUE_APP_ENDPOINT + "/api/JWTUsers/AddSubscriberToUser",
    //                   {
    //                     Id: userId,
    //                     SubscriptionId: ac.Id,
    //                   },
    //                   { headers: { Authorization: `Bearer ` + token } }
    //                 );
    //               } else {
    //                 const updatedCode = await axios
    //                   .patch(
    //                     process.env.VUE_APP_ENDPOINT + `/api/subscriptions`,
    //                     {
    //                       AccessCodeUsed: result?.data[0].SubscriptionTier !== 3,
    //                       JWTUserId: userId,
    //                       Id: result.data[0]?.Id,
    //                       SubscriptionStatus: "Active",
    //                     },
    //                     {
    //                       headers: { Authorization: "Bearer " + token },
    //                     }
    //                   )
    //                   .then((updatedSubscription) => {
    //                     // console.log(updatedSubscription);
    //                     this.accessCodeSuccess = true;
    //                   });
    //               }
    //             }
    //           });
    //       }
    //     });
    // },
    async signOut() {
      let token = localStorage.getItem("user_token");
      if (token == "" || token === undefined) return false;

      const response = await axios
        .post(process.env.VUE_APP_ENDPOINT + "/api/auth/logout", {
          headers: { Authorization: `Bearer ` + token },
        })
        .then((data) => {
          // console.log("datadatadata:", data);

          if (data.authorized == true) {
            //this.$emit("user_authorized", this.authorized)

            // console.log("data.tokendata.token:", data.token);
            // console.log("data.tokendata.user_key:", data.key);
            localStorage.setItem("user_token", data.token);
            localStorage.setItem("user_key", data.key);

            this.token = data.token;

            //this.$emit("user_token", this.token)
            this.$emit("params", {
              user_token: this.token,
              user_attr: data.user_attr,
            });
          }
        })
        .catch((error) => {
          this.errorMessage = error;
          alert("There was an error! : " + error);
        });

      localStorage.setItem("user_token", "");
      localStorage.setItem("user_key", "");

      window.location.href = "/";
    },
    toggleCustomPlan() {
      this.customPlan = !this.customPlan;
    },
  },
  watch: {
    planCount(val, oldVal) {
      this.price = (this.planCount - 1) * 250 + 395;
      // console.log(this.price);
    },
  },
};
</script>
<style scoped>
.selected {
  color: green;
}




.clickable:hover {
  cursor: pointer;
}

.little-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 250px;
  height: 250px;
  border: 2px solid var(--primary-font);
  border-radius: 5px;
}

.mb-0 {
  margin-bottom: 0 !important;
}
</style>
